import React, { useEffect, useState } from 'react';

import { config } from '../../../config/index';
import { newFetch, PUT } from '../../../helpers/fetch';
import { to12Hr, toWeekInt, toWeekString } from '../../../helpers/moment';

import moment from 'moment';
import placeholderImage from '../../../assets/images/placeholder.jpg';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import PerformanceTab from './Performance';
import PreferenceTab from './PreferredShifts';
import PulseSurveyTab from './PulseSurvey';
import ScheduleTab from './Schedule';
import StatusTab from './Status';

const { API_URL, SERVER_URL } = config;

const AssociateSidebar = ({
  sites,
  activeShift,
  activeDate,
  activeSchedules,
  activeSchedule,
  activeClient,
  activeSite,
  activeWeek,
  activeSidebar,
  associate,
  fetchSchedules,
  setActiveSidebar,
  setSidebarMultiAssoc,
  setSidebarMultiAssocLeaves,
  sidebarMultiAssoc,
  sidebarMultiAssocLeaves,
  siteAssociateLeaves,
  statuses,
  assocToEdit,
  activeStatus,
  selectedAssociate,
}) => {
  const token = localStorage.getItem('token');
  let tabs = ['Status', 'Schedule'];
  if (activeClient && activeSite != null) {
    if (
      activeSite.enable_preferred_schedule === true &&
      !selectedAssociate.is_fixed
    )
      tabs.push('Preference');

    if (activeSite.enable_pick_rate === true) tabs.push('Performance');
  }

  const startDay = activeClient ? activeClient.start_day : 0;

  const [activeTab, setActiveTab] = useState('Status');
  const [associateStatus, setAssociateStatus] = useState(null);
  const [associateStatusLogs, setAssociateStatusLogs] = useState([]);
  const [backDropSidebar, setBackDropSidebar] = useState(true);
  const [status, setStatus] = useState(0);

  //update associates shift status
  const handleUpdateShiftStatus = async (e) => {
    e.preventDefault();

    if (!status) {
      ToastUtil.error('Please select status.');
      return false;
    }
    const isConfirmed = await AlertService.confirm(
      '',
      "Are you sure you want to update this Associate's shift status?"
    );
    if (isConfirmed) {
      try {
        setActiveSidebar(false);
        setSidebarMultiAssoc(!sidebarMultiAssoc);
        let ids = assocToEdit.map((assoc) => assoc.id);
        let data = {
          status,
          associate_ids: ids,
        };

        let api_path = `/schedule/${activeSchedule.id}/associate_update`;
        let responseData = await newFetch(PUT, api_path, data);

        if (responseData.success) {
          ToastUtil.success(responseData.message);
          await fetchSchedules(activeSite.id);
        } else {
          ToastUtil.error(
            responseData.data.fail.find((failAssociate) =>
              ids.includes(failAssociate.associate_id)
            ).message
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  //assign the associates to shift
  const handleAssignToShift = async (e) => {
    e.preventDefault();
    const isConfirmed = await AlertService.confirm(
      '',
      'Are you sure you want to assign the Associates to this shift?'
    );
    if (isConfirmed) {
      let url = `/associate/shifts/${activeSchedule.id}/assign`;

      try {
        let ids = assocToEdit.map((assoc) => assoc.id);
        let data = { associate_ids: ids };

        let responseData = await newFetch(PUT, url, data);

        if (responseData.success) {
          ToastUtil.success(responseData.message);
          setSidebarMultiAssoc(!sidebarMultiAssoc);
          await fetchSchedules(activeSite.id);
        } else {
          ToastUtil.error(
            responseData.data.fail.find((failAssociate) =>
              ids.includes(failAssociate.associate_id)
            ).message
          );
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  //fetch associate status
  const fetchAssociateStatus = async () => {
    if (associate.id) {
      let url = `${API_URL}/schedule/${activeSchedule.id}/associate/${associate.id}`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        let data = await response.json();

        if (response.ok) {
          setAssociateStatus(data.data);
        } else {
          console.log('Failed to fetch associates');
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  //fetch associate status
  const fetchAssociateStatusLogs = async () => {
    if (associate.id) {
      let url = `${API_URL}/logs/schedule/${activeSchedule.id}/associate/${associate.id}`;

      try {
        let response = await fetch(url, {
          mode: 'cors',
          method: 'GET',
          withCredentials: true,
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json; charset=utf-8',
          },
        });

        let data = await response.json();

        if (response.ok) {
          setAssociateStatusLogs(data.data);
        } else {
          console.log('Failed to fetch associates');
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (activeSchedule) {
      setAssociateStatus(null);
      fetchAssociateStatus();
      fetchAssociateStatusLogs();
    }
  }, [activeSchedule, activeShift, associate]);

  return (
    <React.Fragment>
      {activeSidebar && (
        <div
          className="right-sidebar-menu pb-4"
          style={
            backDropSidebar
              ? { overflowY: 'auto', zIndex: '200' }
              : { overflowY: 'auto' }
          }
        >
          <div className="x-button-container">
            <button
              className="x-button"
              onClick={() => setActiveSidebar(!activeSidebar)}
            >
              <img
                src="https://server-mae.manpower.com.sg/public/img/6b5786439c.png"
                alt="x-icon"
              />
            </button>
          </div>
          <div className="sidebar-content">
            {/* User Img Holder */}
            <div className="sidebar-user-holder d-flex align-items-center justify-content-center">
              <img
                className="rounded-circle border me-3"
                style={{ width: '75px', height: '75px' }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = placeholderImage;
                }}
                src={
                  associate.image
                    ? `${SERVER_URL}/${associate.image}`
                    : placeholderImage
                }
                alt="user-sidebar-img"
              />
              <div>
                <span>
                  {associate.last_name_first
                    ? `${associate.last_name} ${associate.first_name}`
                    : `${associate.first_name} ${associate.last_name}`}
                </span>
                <span style={{ color: '#aaa' }}>
                  ID: {associate.employee_id}
                </span>
                <span>(#{associate.employee_no})</span>
              </div>
            </div>
            {/* User email and phone no */}
            <div className="d-flex justify-content-between my-4">
              <strong>Email:</strong>
              <span className="text-muted">{associate.email}</span>
            </div>
            <div className="d-l;ex justify-content-between my-4">
              <strong>Employee Type:</strong>
              <span className="text-muted">
                {' '}
                {selectedAssociate.is_fixed ? 'Fixed Sched' : 'Flexi Sched'}
              </span>
            </div>

            <div className="border-separator" />

            <div className="d-flex">
              {tabs.map((tab, index) => (
                <div
                  key={index}
                  className={
                    'flex-grow-1 text-center py-3 fw-bold' +
                    (activeTab === tab ? ' text-brand' : ' text-muted')
                  }
                  onClick={() => setActiveTab(tab)}
                  style={
                    activeTab === tab
                      ? {
                          borderBottom: '5px #5156BE solid',
                          cursor: 'pointer',
                        }
                      : { cursor: 'pointer' }
                  }
                >
                  {tab}
                </div>
              ))}
            </div>

            {activeTab === 'Status' ? (
              <StatusTab
                associate={associate}
                activeSchedule={activeSchedule}
                associateStatus={associateStatus}
                setBackDropSidebar={setBackDropSidebar}
                activeClient={activeClient}
                activeSite={activeSite}
                fetchSchedules={fetchSchedules}
                associateStatusLogs={associateStatusLogs}
                setActiveSidebar={setActiveSidebar}
              />
            ) : activeTab === 'Schedule' ? (
              <ScheduleTab
                sites={sites}
                activeShift={activeShift}
                activeDate={activeDate}
                activeSchedules={activeSchedules}
                associate={associate}
                activeClient={activeClient}
                activeSite={activeSite}
                activeWeek={activeWeek}
              />
            ) : activeTab === 'Preference' ? (
              <PreferenceTab
                sites={sites}
                activeShift={activeShift}
                activeDate={activeDate}
                activeSchedules={activeSchedules}
                associate={associate}
                activeClient={activeClient}
                activeSite={activeSite}
                activeWeek={activeWeek}
              />
            ) : activeTab === 'Performance' ? (
              <PerformanceTab
                activeDate={activeDate}
                activeSchedules={activeSchedules}
                associate={associate}
                activeClient={activeClient}
                activeWeek={activeWeek}
                activeSite={activeSite}
              />
            ) : activeTab === 'Survey' ? (
              <PulseSurveyTab />
            ) : null}
          </div>
        </div>
      )}

      {sidebarMultiAssoc && (
        <div
          className="right-sidebar-menu pb-4"
          style={{ overflowY: 'auto', width: '30%', zIndex: '200' }}
        >
          <div className="x-button-container">
            <button
              className="x-button"
              onClick={() => setSidebarMultiAssoc(!sidebarMultiAssoc)}
            >
              <img
                src="https://server-mae.manpower.com.sg/public/img/6b5786439c.png"
                alt="x-icon"
                style={{ height: '20px', width: '20px' }}
              />
            </button>
          </div>
          <div className="sidebar-content">
            <div className="pt-4">
              <div className="h-100">
                {activeStatus == 'Not Assigned' ? (
                  <form
                    className="d-flex flex-column justify-content-between align-items-center flex-grow-1 mb-4"
                    onSubmit={(e) => handleAssignToShift(e)}
                  >
                    <div className="d-flex mt-auto pt-3">
                      <button
                        type="submit"
                        className="btn btn-brand"
                        style={{ width: '11rem' }}
                      >
                        Assign to this shift
                      </button>
                    </div>
                    <h5 style={{ fontSize: '15px' }} className="pt-2">
                      {moment(activeSchedule.date).format('DD/MM/YYYY')} -{' '}
                      {activeSchedule.shift.name} (
                      {to12Hr(activeSchedule.shift.start_time)} -{' '}
                      {to12Hr(activeSchedule.shift.end_time)})
                    </h5>
                  </form>
                ) : (
                  <form
                    className="d-flex flex-column justify-content-between flex-grow-1 mb-4"
                    onSubmit={(e) => handleUpdateShiftStatus(e)}
                  >
                    <h5 style={{ marginBottom: '0.2rem' }}>
                      Update Shift Status
                    </h5>
                    <div className="mb-2 pb-3">
                      <label htmlFor="shiftName">
                        {moment(activeSchedule.date).format('DD/MM/YYYY')} -{' '}
                        {activeSchedule.shift.name} (
                        {to12Hr(activeSchedule.shift.start_time)} -{' '}
                        {to12Hr(activeSchedule.shift.end_time)})
                      </label>
                    </div>
                    <div className="row">
                      <div className="col">
                        <div className="mb-2">
                          <label htmlFor="shiftEndTime">Status</label>
                          <select
                            name="shiftStatus"
                            id="shiftStatus"
                            className="form-select"
                            style={{ width: '18rem' }}
                            value={status}
                            onChange={({ target: { value } }) =>
                              setStatus(value)
                            }
                          >
                            <option value>Select status</option>
                            {statuses.length > 0 &&
                              statuses.map((status, index) => (
                                <option key={index} value={status.id}>
                                  {status.status}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex mt-auto pt-3">
                      <button
                        type="submit"
                        className="btn btn-brand"
                        style={{ width: '9rem' }}
                      >
                        Update
                      </button>
                    </div>
                  </form>
                )}
              </div>
            </div>
            <div className="pt-1">
              {assocToEdit.map((associate, index) => (
                <div
                  key={index}
                  className="non-team-support pb-2 d-flex align-items-center"
                  style={{ width: '100%' }}
                >
                  <div>
                    <img
                      className="img-responsive rounded-circle border"
                      style={{ width: '45px', height: '45px' }}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = placeholderImage;
                      }}
                      src={
                        associate.image
                          ? `${SERVER_URL}/${associate.image}`
                          : placeholderImage
                      }
                      alt="username-img"
                    />
                  </div>
                  <div className="ps-4">
                    <p className="mb-0">
                      {associate.last_name_first
                        ? `${associate.last_name} ${associate.first_name}`
                        : `${associate.first_name} ${associate.last_name}`}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {sidebarMultiAssocLeaves && (
        <div
          className="right-sidebar-menu pb-4"
          style={{ overflowY: 'auto', width: '45%', zIndex: '200' }}
        >
          <div className="x-button-container">
            <button
              className="x-button"
              onClick={() =>
                setSidebarMultiAssocLeaves(!sidebarMultiAssocLeaves)
              }
            >
              <img
                src="https://server-mae.manpower.com.sg/public/img/6b5786439c.png"
                alt="x-icon"
                style={{ height: '30px', width: '30px' }}
              />
            </button>
          </div>
          <div className="sidebar-content" style={{ marginTop: 0 }}>
            <div className="pb-2 py-4">
              <div className="pb-2">
                Week {toWeekInt(activeWeek.startDate, startDay)}
              </div>
              <h6 style={{ fontSize: '1.2rem' }}>
                {toWeekString(activeWeek.startDate, startDay)}
              </h6>
            </div>
            <div className="table-responsive rounded shadow bg-white">
              <table className="table table-borderless mb-0">
                <thead className="border-bottom">
                  <tr>
                    <th>Name</th>
                    <th>Leave Type</th>
                    <th width="20%">Leave Date</th>
                  </tr>
                </thead>
                <tbody>
                  {siteAssociateLeaves.length > 0 ? (
                    siteAssociateLeaves.map((item, index) => (
                      <tr key={index}>
                        <td>
                          {item.CandFirstName} {item.CandLastName}
                        </td>
                        <td>{item.LeaveDescription}</td>
                        <td width="20%">
                          {moment(item.leave_date).format('DD MMMM YYYY')}
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr className="border-bottom">
                      <td colSpan="5" className="text-center py-4">
                        No associate leave found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {(sidebarMultiAssoc || sidebarMultiAssocLeaves || activeSidebar) &&
        backDropSidebar && (
          <div
            className="modal-backdrop fade in"
            style={{ opacity: '0.3', zIndex: '100' }}
            onClick={() => {
              setActiveSidebar(false);
              setSidebarMultiAssoc(false);
              setSidebarMultiAssocLeaves(false);
            }}
          ></div>
        )}
    </React.Fragment>
  );
};

export default AssociateSidebar;
